import React from "react"
import { Link } from "react-router-dom"

import PageBanner from "../../layouts/PageBanner"

//images
import bg from "../../assets/images/banner/bnr4.jpg"
import shape2 from "../../assets/images/pattern/shape2.png"
import shape3 from "../../assets/images/pattern/shape3.png"
import shape5 from "../../assets/images/pattern/shape5.png"
import shape1 from "../../assets/images/pattern/shape1.png"
import shape6 from "../../assets/images/pattern/shape6.png"
import { Table } from "reactstrap"
import YouthWingBlock from "../../components/YouthWingBlock"
import YouthClubBlock from "../../components/YouthClubBlock"
import YouthClubBook from "../../components/YouthClubBook"

// Members
import sanjay from "../../assets/images/SATS club/youth/Members/Sanjay.jpg"
import shakthi from "../../assets/images/SATS club/youth/Members/Shakthi .jpg"
import sachin from "../../assets/images/SATS club/youth/Members/Sachin.jpeg"
import sanjith from "../../assets/images/SATS club/youth/Members/Sanjith.jpg"
import maniish from "../../assets/images/SATS club/youth/Members/Maniish Shravan .jpg"
import afra from "../../assets/images/SATS club/youth/Members/Afra.jpeg"
import ashwin from "../../assets/images/SATS club/youth/Members/Ashwin.jpeg"
import harini from "../../assets/images/SATS club/youth/Members/Harini.png"
import jithesh from "../../assets/images/SATS club/youth/Members/Jithesh.jpeg"
import nihil from "../../assets/images/SATS club/youth/Members/Nihil.jpeg"
import yashna from "../../assets/images/SATS club/youth/Members/Yashna.png"

import YouthWingDiscussion from "../../components/YouthWingDiscussion"
const YouthWing = () => {
  const YouthWingMembers = [
  {
    name: "Sanjay Rajaguru",
    image: sanjay,
    Role: "President",
  },
  {
    name: "Shakthi Maharaja Thirumal Murugan",
    image: shakthi,
    Role: "Vice President",
  },
  {
    name: "Sachin Kumar",
    image: sachin,
    Role: "Secretary",
  },
  {
    name: "Sanjith Balusamy",
    image: sanjith,
    Role: "Joint Secretary",
  },
  {
    name: "Maniish Shravan Sridhar",
    image: maniish,
    Role: "Treasurer",
  },
  {
    name: "Afra Serafin John SathishBabu",
    image: afra,
    Role: "Executive Committee Member",
  },
  {
    name: "Ashwin Rajesh",
    image: ashwin,
    Role: "Executive Committee Member",
  },
  {
    name: "Harini Sadhish Kumar",
    image: harini,
    Role: "Executive Committee Member",
  },
  {
    name: "Jithesh Santhana Krishnan",
    image: jithesh,
    Role: "Executive Committee Member",
  },
  {
    name: "Nihil Adithya Balashiva",
    image: nihil,
    Role: "Executive Committee Member",
  },
  {
    name: "Yashna Gohul Raaj",
    image: yashna,
    Role: "Executive Committee Member",
  },
]


  
  return (
    <>
      <div className="page-content bg-white text-dark">
        <PageBanner maintitle="Home" pagetitle="Youth Wing" />
          <section
          className="content-inner-2 bg-light section-pattren1"
          style={{ paddingTop: 30 }}>
          <YouthWingDiscussion/>
          </section>


        <section
          className="content-inner-2 bg-light section-pattren1"
          style={{ paddingTop: 30 }}
        >
          <div className="container">
            <div className="row about-bx3 align-items-center">
              <YouthWingBlock />
            </div>
          </div>

          <img src={shape2} className="shape-6 move-2" alt="shape" />
          <img src={shape3} className="shape-5 move-1" alt="shape" />
          <img src={shape5} className="shape-1 rotating" alt="shape" />
          <img src={shape1} className="shape-3 move-1" alt="shape" />
          <img src={shape6} className="shape-4 rotating" alt="shape" />
          <img src={shape6} className="shape-2 rotating" alt="shape" />
        </section>
        <section
          className="content-inner-2 section-pattren1"
          style={{ paddingTop: 50 }}
        >
          <div className="container">
            <div className="row about-bx3 align-items-center">
              <YouthClubBlock />
            </div>
          </div>
          {/* <div className="container">
            <div className="row about-bx3 align-items-center">
              <YouthClubBook />
            </div>
          </div> */}

          <img src={shape2} className="shape-6 move-2" alt="shape" />
          <img src={shape3} className="shape-5 move-1" alt="shape" />
          <img src={shape5} className="shape-1 rotating" alt="shape" />
          <img src={shape1} className="shape-3 move-1" alt="shape" />
          <img src={shape6} className="shape-4 rotating" alt="shape" />
          <img src={shape6} className="shape-2 rotating" alt="shape" />
        </section>
        <section
          className="content-inner-2 section-pattren1"
          style={{ paddingTop: 50 }}
        >
          <div className="container">
            <div className="row">
              <h2 className="text-primary text-center border-bottom pb-2">
                Youth Wing Team
              </h2>
              <Table hover>
                <thead>
                  <tr>
                    <th>Profile</th>
                    <th>Name</th>
                    <th>Role</th>
                  </tr>
                </thead>
                <tbody>
                  {YouthWingMembers.map((item, ind) => (
                    <tr key={ind}>
                      <td>
                        <div style={{ height: "100px", width: "100px" }}>
                          <img src={item.image} style={{ width: "100%" ,height: "100%", objectFit: "contain"}}></img>
                        </div>
                      </td>
                      <td className="align-self-center">{item.name}</td>
                      <td>{item.Role}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>

          <img src={shape2} className="shape-6 move-2" alt="shape" />
          <img src={shape3} className="shape-5 move-1" alt="shape" />
          <img src={shape5} className="shape-1 rotating" alt="shape" />
          <img src={shape1} className="shape-3 move-1" alt="shape" />
          <img src={shape6} className="shape-4 rotating" alt="shape" />
          <img src={shape6} className="shape-2 rotating" alt="shape" />
        </section>
      </div>
    </>
  )
}

export default YouthWing
